import {DICTIONARIES} from '../../actions/dictionaries/dictionariesActionsTypes';

const INITIAL_STATE = {
  editPopup: {
    type: '',
    visible: false,
    data: {}
  }
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case DICTIONARIES.SET_MODAL_POPUP:
      return {
        ...state,
        editPopup: {
          type: action.payload.type,
          visible: true,
          data: action.payload.data
        }
      };
    case DICTIONARIES.CLOSE_MODAL_POPUP:
      return {
        ...state,
        editPopup: {
          ...state.editPopup,
          visible: false
        }
      };
    case DICTIONARIES.RESET_ALL:
      return {
        ...state,
        editPopup: {
          type: '',
          visible: false,
          data: {}
        }
      };

    default:
      return state;
  }
}
